/**
 * The building part a comparable sale sold, from a transaction-details payload
 * (`TransactionResource`). `building_parts` is keyed by part id, so its first
 * key is the LOWEST id, not the sold flat: the importer links the flat with the
 * sale's number in every house on the cadaster (RED-355), so on a multi-part
 * sale the first key is often another house's flat. The server names the sold
 * part in `sold_building_part_id` (`Transaction::soldBuildingPart()`, the part
 * training reads), and every cell and inline edit must use that one.
 *
 * Only a payload without the field (an older cached response) falls back to
 * the first part.
 *
 * @param {object|null|undefined} transaction  transaction-details payload
 * @returns {object|null} the sold part, or null when none is linked
 */
export function soldBuildingPart(transaction) {
  const parts = transaction?.building_parts
  if (!parts || typeof parts !== 'object') {
    return null
  }

  if ('sold_building_part_id' in transaction) {
    const soldId = transaction.sold_building_part_id
    return soldId == null ? null : (parts[soldId] ?? null)
  }

  const firstKey = Object.keys(parts)[0]
  return firstKey === undefined ? null : parts[firstKey]
}
